export const CREATE = "confirmModal.CREATE";
export const REMOVE = "confirmModal.REMOVE";
